// extracted by mini-css-extract-plugin
export default {"wrapped":"textarea__wrapped-Bk7CX","simple":"textarea__simple-DDhqL","error":"textarea__error-jHfUY","normal":"textarea__normal-XSVhj"};